import { Section as SectionType } from '../../types';
import AddChordButton from '../Buttons/AddChordButton';
import Chord from '../Chord';
import ProgressLine from './ProgressLine';
import SectionFooter from './SectionFooter';
import SectionHeader from './SectionHeader';
import { StyledSection } from './styles';

interface Props {
	chordMeasureIndex: number;
	section: SectionType;
}

export default function Section({ chordMeasureIndex, section }: Props) {
	return (
		<StyledSection isEnabled={section.enabled}>
			<SectionHeader section={section} />
			{section.chords.map(chord => {
				const rtn = (
					<Chord key={chord.id} chord={chord} chordMeasureIndex={chordMeasureIndex} />
				);
				chordMeasureIndex += chord.length;
				return rtn;
			})}
			<AddChordButton sectionId={section.id} />
			<ProgressLine section={section} />
			<SectionFooter section={section} />
		</StyledSection>
	);
}
